import OrderMissingPart from './OrderMissingPart';
import { withI18n } from 'react-i18next';

export default withI18n()(OrderMissingPart);
